<header class="header-like-campus">
  <div class="content-like-campus">
    <div class="header-like-campus--components">
      <div class="header-like-campus__logowrap">
        <img
          class="header-like-campus__logo"
          src="https://min.gamelearn.io/css-resources/gamelearn/resources/campus/logo-gamelearn.svg"
        />
      </div>
      <a
        routerLink="/login"
        [queryParams]="{ sid: marsSid }"
        role="button"
        class="header-like-campus__logout"
      >
        <span class="glicon-logout"></span>
        <span>{{ 'actions.logOut' | translate }}</span>
      </a>
    </div>
  </div>
</header>
<main class="main--campus main--campus--clients-selector" role="main">
  <div class="content-like-campus">
    <div class="clients-selector">
      <div class="clients-selector__content">
        <img
          class="clients-selector__marslogo"
          src="https://min.objects.gamelearn.io/statics.mars/statics/logo.png"
          alt="Mars"
        />
        <h1 class="clients-selector__title">{{ 'clientSelector.selectMatchTitle' | translate }}</h1>
        <div class="clients-selector__subtitle">
          {{ 'clientSelector.subtitle' | translate }}
          <b *ngIf="groups[0]">{{ groups[0].email }}</b>
        </div>
        <div *ngIf="error">
          <p class="error">
            {{ 'nouns.error' | translate }}: {{ 'apiErrors.' + error.errorCode | translate }}.
          </p>
          <a routerLink="/login" role="button">{{ 'actions.logInAgain' | translate }}</a>
        </div>
        <!-- Layoput cards -->
        <ul class="clients-selector__cards">
          <li
            class="clients-selector__card buttons-design-system"
            *ngFor="let group of groups"
            (click)="handleSelectMatch(group.licenseId)"
          >
            <div class="clients-selector__user">
              <div class="clients-selector__avatar">
                <img *ngIf="group.logo" [src]="group.logo" alt="" />
                <div *ngIf="!group.logo" class="clients-selector__initial">
                  <span> {{ group.license.groupName.charAt(0) }}</span>
                </div>
              </div>
              <div class="clients-selector__username">
                <div class="u-text-ellipsis">
                  {{ group.license.groupName }}
                </div>
              </div>
            </div>
            <div class="clients-selector__button btn btn--primary">
              {{ 'clientSelector.select' | translate }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</main>
<div class="footer-like-campus">
  <span>Powered by Gamelearn</span>
  <span>© Gamelearn {{ utilsService.getYear() }}</span>
</div>
